<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<template lang="pug">

  div

    div.c-auth-page__head
      h1 {{ $t('h1') }}

    div
      p Уважаемый {{firstName}} {{lastName}}, вы успешно зарегистрирвались в Deliver!
      p На ваш email &laquo;{{email}}&raquo; отправлено письмо с инструкциями

    div.mt-5
      a.btn.btn-primary(v-bind:href="returnUrl") Войти в Deliver


</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('registration', [
      'email',
      'firstName',
      'lastName',
      'cookie',
      'returnUrl',
      'phoneNumberE164',
    ]),
  },

  validations: {
    cookie: { required },
    returnUrl: { required },
  },

  mounted() {
    if (this.$v.$invalid) {
      this.$router.push({ name: 'enter-number' });
    }
  },
};
</script>
